//------------------------------------------------------------------------------
//  This code was generated by typescript template tool 'Typewriter'.
//
//  Changes to this file may cause incorrect behavior and will be lost if
//  the code is regenerated.
//------------------------------------------------------------------------------


import { Injectable } from "@angular/core";
//import { ResponseContentType, Response } from "@angular/http";
import { Observable } from 'rxjs';
import { BasApiService } from '../base.api.service';
import {GridApiService} from './grid.api.service';
import * as ApiTypes from "../../models";

@Injectable()
export class SalaryBookApiService extends GridApiService<ApiTypes.SalaryBookViewModel,ApiTypes.SalaryBookViewFilterModels>{
  
  constructor(public baseService: BasApiService) {
   super(baseService);
    this.apiKey = "api/salaryBook";
  }
  
  delete = (workTypeId: number, protezId: number, personId: number): Observable<void> =>
    this.baseService.delete<void>(`api/SalaryBook/${workTypeId}/${protezId}/${personId}`, {}, true, true);   
  
  save = (model: ApiTypes.SalaryBookViewModel): Observable<void> =>
    this.baseService.post<void>(`api/SalaryBook`, model, {}, true, true);   
  
  edit = (model: ApiTypes.FilteredGridRequestViewModel<ApiTypes.SalaryBookViewModel>): Observable<void> =>
    this.baseService.put<void>(`api/SalaryBook`, model, {}, true, true);   
  
  }

